import { CreateCongresDialogComponent } from './../../../gt2/content/congresses/create-congres-dialog/create-congres-dialog.component';
import {
  Component,
  HostListener,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { of, Subject } from 'rxjs';
import { catchError, debounceTime, switchMap, takeUntil } from 'rxjs/operators';
import { SearchSuggestionModelData } from '../../../gt2/api/models/SearchSuggestionModel';
import {
  searchResultIconKey,
  searchResultUrl,
} from '../../../gt2/utils/search-suggestion-url';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { FuseConfigService } from '../../../../@fuse/services/config.service';
import { FuseSidebarService } from '../../../../@fuse/components/sidebar/sidebar.service';
import { ChatSidePanelService } from '../../../gt2/services/chat-side-panel.service';
import { navigation } from '../../../navigation/navigation';
import { locale as english } from './i18n/en-CA';
import { locale as french } from './i18n/fr-CA';
import { FuseTranslationLoaderService } from '../../../../@fuse/services/translation-loader.service';
import { AuthenticationService } from '../../../gt2/api/auth-service.service';
import { SearchService } from '../../../gt2/api/search.service';
import { SearchResultsSharedDataService } from '../../../gt2/content/search-results/search-results-shared-data.service';
import { CrudEmployeeService } from '../../../gt2/content/crud/crud-employee/crud-employee.service';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { EmployeeModelData } from '../../../gt2/api/models/CrudEmployeeModel';
import { P } from '../../../gt2/const/Permissions';
import { Router, RouterModule } from '@angular/router';
import { CreateEmployeeComponent } from '../../../gt2/components/dialogs/create-employee/create-employee.component';
import { CreateProductComponent } from '../../../gt2/components/dialogs/create-product/create-product.component';
import { CreatePlaceComponent } from '../../../gt2/components/dialogs/create-place/create-place.component';
import { CreateEnterpriseComponent } from '../../../gt2/components/dialogs/create-enterprise/create-enterprise.component';
import { CreateClientComponent } from '../../../gt2/components/dialogs/create-client/create-client.component';
import { CreateMaterialComponent } from '../../../gt2/components/dialogs/create-material/create-material.component';
import { LocalizationConfig } from '../../../localization/LocalizationConfig';
import { AppRoutes } from '../../../gt2/const/AppRoutes';
import { EditComboPanelService } from '../../../gt2/services/edit-combo-panel.service';
import { ItemUrlFinder } from '../../../gt2/utils/item-url-finder';
import { NGXLogger } from 'ngx-logger';
import { DeviceDetectorService, DEVICES } from 'ngx-device-detector';
import { EditMaterialComboPanelService } from '../../../gt2/services/edit-material-combo-panel.service';
import { IconsService } from '../../../gt2/services/icons.service';
import { CreateEventComponent } from '../../../gt2/components/dialogs/create-event/create-event.component';
import { CrudOrganizationService } from '../../../gt2/content/crud/crud-organization/crud-organization.service';
import { JwtInterceptor } from '../../../gt2/interceptors/JwtInterceptor';
import { ModulesService } from '../../../gt2/services/modules.service';
import { QuickOrderPanelService } from '../../../gt2/services/quick-order-panel.service';
import { RolesService } from '../../../gt2/services/roles.service';
import { FeatureTrackingService } from '../../../gt2/services/feature-tracking.service';
import { PageHistory } from '../../../gt2/benching/page-history';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Gt2ApiService } from '../../../gt2/api/gt2-api.service';
import { switchTheme } from '../../../fuse-config';
import { AppRoutesName } from '../../../gt2/const/AppRoutesName';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule, DOCUMENT } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FuseDirectivesModule } from '../../../../@fuse/directives/directives';
import {
  FuseSearchBarModule,
  FuseShortcutsModule,
} from '../../../../@fuse/components';
import { FusePipesModule } from '../../../../@fuse/pipes/pipes.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import moment from 'moment';
import { FuseFullscreenComponent } from '../../../../@fuse/components/fullscreen/fullscreen.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CreateClientEnterpriseComponent } from '../../../gt2/components/dialogs/create-client-enterprise/create-client-enterprise.component';
import { CreateComboDynamicComponent } from '../../../gt2/components/dialogs/create-combo-dynamic/create-combo-dynamic.component';
import { BellNotificationsService } from '../../../gt2/services/bell-notifications.service';
import { BellPanelService } from '../../../gt2/services/bell-panel.service';
import { UserLanguageService } from '../../../gt2/api/user-language.service';

@Component({
  selector: 'toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  standalone: true,
  imports: [
    RouterModule,
    MatButtonModule,
    TranslateModule,
    MatInputModule,
    MatIconModule,
    FuseSearchBarModule,
    MatMenuModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatToolbarModule,
    CommonModule,
    FuseFullscreenComponent,
    NgxPermissionsModule,
    FormsModule,
    ReactiveFormsModule,
    FuseDirectivesModule,
    FusePipesModule,
    FuseShortcutsModule,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class ToolbarComponent implements OnInit, OnDestroy {
  /** Capacités (permissions par rôle) pour les gardes du template. */
  readonly P = P;
  /** Unread notifications of the bell (0 = no badge). */
  unreadNotifications: number = 0;

  employee?: EmployeeModelData;
  caterer: any;
  organization: any; // OrganizationModel;
  dialogRef: any;
  isMobile: boolean = false;
  isSmallScreen: boolean = false;
  isMediumScreen: boolean = false;
  isMac: boolean = false;

  // Keyboard shortcuts: Alt+Shift+P for Proposal, Alt+Shift+C for Order (Commande)
  @HostListener('window:keydown', ['$event'])
  handleKeyboardShortcuts(event: KeyboardEvent) {
    // Check for Alt+Shift (use event.code for physical key, ignoring special characters)
    if (event.altKey && event.shiftKey) {
      console.log('Keyboard shortcut detected - code:', event.code);
      if (event.code === 'KeyP') {
        event.preventDefault();
        this.featureTracking.trackFeature('use-short-cut-new-proposal');
        this.onCreateNewProposal();
      } else if (event.code === 'KeyC') {
        event.preventDefault();
        this.featureTracking.trackFeature('use-short-cut-new-order');
        this.onCreateNewOrder();
      }
    }
  }

  // Explicit ref so the create menu trigger isn't shadowed by the quick-order
  // menu trigger that now precedes it in the DOM.
  @ViewChild('createMenuTrigger', { static: false, read: MatMenuTrigger })
  trigger?: MatMenuTrigger;

  @ViewChild('quickOrderMenuTrigger', { static: false, read: MatMenuTrigger })
  quickOrderTrigger?: MatMenuTrigger;

  @ViewChild('historyMenuTrigger', { static: false, read: MatMenuTrigger })
  historyTrigger?: MatMenuTrigger;
  @ViewChild('userMenuTrigger', { static: false, read: MatMenuTrigger })
  userTrigger?: MatMenuTrigger;
  @ViewChild('createMenuButton')
  createMenuButton?: MatButton;

  //
  horizontalNavbar?: boolean;
  rightNavbar?: boolean;
  hiddenNavbar?: boolean;
  languages: any;
  modeText?: string;
  navigation: any;
  selectedLanguage: any;
  loading: boolean = false;
  userStatusOptions: any[];

  // Private
  private _unsubscribeAll: Subject<any>;
  history?: import('../../../gt2/benching/page-history').HistoryStack[];
  histories: import('../../../gt2/benching/page-history').HistoryStack[];
  private _document = inject(DOCUMENT);

  /*
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   * @param {FuseSidebarService} _fuseSidebarService
   * @param {TranslateService} _translateService
   */
  constructor(
    private _fuseConfigService: FuseConfigService,
    public rolesService: RolesService,
    private _fuseSidebarService: FuseSidebarService,
    private chatSidePanelService: ChatSidePanelService,
    private editMaterialComboPanelService: EditMaterialComboPanelService,
    private editComboPanelService: EditComboPanelService,
    private _translateService: TranslateService,
    private translationLoader: FuseTranslationLoaderService,
    private auth: AuthenticationService,
    private searchService: SearchService,
    private searchResultsSharedDataService: SearchResultsSharedDataService,
    public dialog: MatDialog,
    private router: Router,
    public logger: NGXLogger,
    private deviceService: DeviceDetectorService,
    private employeeService: CrudEmployeeService,
    public iconsService: IconsService,
    public modulesService: ModulesService,
    private orgService: CrudOrganizationService,
    private breakpointObserver: BreakpointObserver,
    private api: Gt2ApiService,
    private featureTracking: FeatureTrackingService,
    private quickOrderPanelService: QuickOrderPanelService,
    private bellNotificationsService: BellNotificationsService,
    private bellPanelService: BellPanelService,
    private userLanguageService: UserLanguageService,
  ) {
    this.translationLoader.loadTranslations(english, french);

    // Detect platform for keyboard shortcut display
    this.isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

    this.histories = PageHistory.callStack;
    PageHistory.callStackChanged.subscribe({
      next: (callStack) => {
        this.histories = callStack;
      },
    });

    // Set the defaults
    this.userStatusOptions = [
      {
        title: 'Online',
        icon: 'icon-checkbox-marked-circle',
        color: '#4CAF50',
      },
      {
        title: 'Away',
        icon: 'icon-clock',
        color: '#FFC107',
      },
      {
        title: 'Do not Disturb',
        icon: 'icon-minus-circle',
        color: '#F44336',
      },
      {
        title: 'Invisible',
        icon: 'icon-checkbox-blank-circle-outline',
        color: '#BDBDBD',
      },
      {
        title: 'Offline',
        icon: 'icon-checkbox-blank-circle-outline',
        color: '#616161',
      },
    ];

    this.languages = [
      {
        id: 'en-CA',
        title: 'Français',
        shortTitle: 'FR',
        flag: 'fr',
      },
      {
        id: 'fr-CA',
        title: 'English',
        shortTitle: 'EN',
        flag: 'us',
      },
    ];

    this.navigation = navigation;

    // Set the private defaults
    this._unsubscribeAll = new Subject();

    // user
    this.employeeService.employee.subscribe({
      next: (employee: any) => {
        if (employee) {
          this.employee = employee;
          // Langue choisie avec la bascule FR/EN avant le rechargement de la page.
          this.userLanguageService.savePending(employee.uuid);
        }
      },
    });

    this.orgService.getOrganization().subscribe({
      next: (organization) => {
        if (organization?.data) {
          this.organization = organization.data;
          if (organization.data.caterer) {
            this.caterer = { data: organization.data.caterer };
          }
        }
      },
    });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  // ---o Type-ahead (Meilisearch seulement : SearchService.suggestionsEnabled()) : suggestions sous la barre à partir de 2 caractères.
  suggestions: SearchSuggestionModelData[] = [];
  suggestionsOpen: boolean = false;
  activeSuggestion: number = -1;
  suggestionKey: string = '';
  private suggestInput$ = new Subject<string>();

  private setupSuggestions(): void {
    this.suggestInput$
      .pipe(
        debounceTime(200),
        // Pas de distinctUntilChanged : après Échap, retaper le même terme doit rouvrir le menu.
        switchMap((key: string) => {
          if (
            !SearchService.suggestionsEnabled() ||
            !key ||
            key.trim().length < 2
          ) {
            return of(null);
          }
          return this.searchService
            .suggest(key.trim())
            .pipe(catchError(() => of(null)));
        }),
        takeUntil(this._unsubscribeAll),
      )
      .subscribe((response) => {
        if (!response || !response.data) {
          this.closeSuggestions();
          return;
        }
        this.suggestions = response.data;
        this.suggestionKey = response.meta?.key || '';
        this.activeSuggestion = -1;
        this.suggestionsOpen = this.suggestions.length > 0;
      });
  }

  public closeSuggestions(): void {
    this.suggestions = [];
    this.suggestionsOpen = false;
    this.activeSuggestion = -1;
  }

  public suggestionIcon(item: SearchSuggestionModelData): string {
    return this.iconsService.getIcon(searchResultIconKey(item));
  }

  public openSuggestion(item: SearchSuggestionModelData): void {
    const url = searchResultUrl(item);
    this.closeSuggestions();
    if (!url) {
      return;
    }
    const prefix = localStorage.getItem('PREFIX') || '';
    this.router.navigateByUrl(prefix + url);
  }

  /** Flèches / Échap pendant que le menu est ouvert ; Entrée est géré dans search(). */
  @HostListener('document:keydown', ['$event'])
  onSuggestionsKeydown(event: KeyboardEvent): void {
    if (!this.suggestionsOpen) {
      return;
    }
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.activeSuggestion =
        (this.activeSuggestion + 1) % this.suggestions.length;
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.activeSuggestion =
        (this.activeSuggestion - 1 + this.suggestions.length) %
        this.suggestions.length;
    } else if (event.key === 'Escape') {
      this.closeSuggestions();
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClickForSuggestions(event: MouseEvent): void {
    if (!this.suggestionsOpen) {
      return;
    }
    const target = event.target as HTMLElement | null;
    if (target && target.closest('.search-suggestions, fuse-search-bar')) {
      return;
    }
    this.closeSuggestions();
  }

  ngOnInit(): void {
    this.setupSuggestions();
    this.bellNotificationsService.unreadCount$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (count: number) => {
          this.unreadNotifications = count;
        },
      });
    // Subscribe to the config changes
    this.modeText =
      localStorage.getItem('theme') === 'theme-default'
        ? this._translateService.instant('TOOLBAR.DARKMODE')
        : this._translateService.instant('TOOLBAR.LIGTHMODE');
    localStorage.setItem('API_URL', this.api.getDomainUrl() + '/v1/');
    this.breakpointObserver.observe(['(max-width: 599px)']).subscribe({
      next: (result) => {
        this.isSmallScreen = result.matches;
      },
    });
    this.breakpointObserver.observe(['(max-width: 959px)']).subscribe({
      next: (result) => {
        this.isMediumScreen = result.matches;
      },
    });
    this._fuseConfigService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (settings: any) => {
          this.horizontalNavbar = settings.layout.navbar.position === 'top';
          this.rightNavbar = settings.layout.navbar.position === 'right';
          this.hiddenNavbar = settings.layout.navbar.hidden === true;
        },
      });

    // Set the selected language from default languages
    this.selectedLanguage = _.find(this.languages, {
      id: this._translateService.currentLang,
    });
    this.isMobile = this.detectMobileDevice();

    // this.logger.info("this.selectedLanguage: " + this.selectedLanguage);
  }
  detectMobileDevice(): boolean {
    return this.deviceService.isMobile() || this.deviceService.isTablet();
  }
  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(undefined);
    this._unsubscribeAll.complete();
  }

  toggleTheme() {
    switchTheme();
    this.featureTracking.trackFeature(
      localStorage.getItem('theme') === 'theme-default'
        ? 'lite-mode'
        : 'dark-mode',
    );
    this.modeText =
      localStorage.getItem('theme') === 'theme-default'
        ? this._translateService.instant('TOOLBAR.DARKMODE')
        : this._translateService.instant('TOOLBAR.LIGTHMODE');
  }
  toggleFullscreen(): void {
    this.featureTracking.trackFeature('full-screen');
    if (!this._document.fullscreenEnabled) {
      return;
    }

    // Check if the fullscreen is already open
    const fullScreen = this._document.fullscreenElement;

    // Toggle the fullscreen
    if (fullScreen) {
      this._document.exitFullscreen();
    } else {
      this._document.documentElement.requestFullscreen().catch(() => {
        console.error('Entering fullscreen mode failed.');
      });
    }
  }
  toggleLang() {
    const langg = localStorage.getItem(LocalizationConfig.LOCAL_STORED_LANG_ID);
    const lang = this.languages.find((l: any) => l.id !== langg);
    this.selectedLanguage = lang;
    this.featureTracking.trackFeature(
      lang.id === 'en-CA' ? 'english-ui' : 'french-ui',
    );

    localStorage.setItem(LocalizationConfig.LOCAL_STORED_LANG_ID, lang.id);
    // Sauvegardée côté serveur par la page rechargée (UserLanguageService).
    this.userLanguageService.remember(lang.id, this.employee?.uuid);
    // Update page data
    this.fromUrlFrToEn();
    moment.locale(lang.id);
    // Use the selected language for translations
    this._translateService.use(lang.id);
  }
  fromUrlFrToEn() {
    const currentUrl = window.location.href;

    const routeKeys = Object.keys(AppRoutes);
    for (const key of routeKeys) {
      //@ts-ignore
      const routeFR = '/' + AppRoutesName.FR[key];
      //@ts-ignore
      const routeEN = '/' + AppRoutesName.EN[key];

      if (currentUrl.includes(routeFR)) {
        window.location.href = currentUrl.replace(routeFR, routeEN);
        return;
      } else if (currentUrl.includes(routeEN)) {
        window.location.href = currentUrl.replace(routeEN, routeFR);
        return;
      }
    }

    window.location.href = currentUrl;
    return;
  }
  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle sidebar open
   *
   * @param key
   */
  toggleSidebarOpen(key: any): void {
    this._fuseSidebarService.getSidebar(key).toggleOpen();
  }

  /** Ouvre/ferme le panneau latéral Chat (contenu de la page /chat, GOD). */
  toggleChatPanel(): void {
    this.chatSidePanelService.toggle();
  }

  openHistoryMenu(): void {
    if (this.historyTrigger) {
      this.historyTrigger.openMenu();
    }
  }

  closeHistoryMenu(): void {
    if (this.historyTrigger) {
      this.historyTrigger.closeMenu();
    }
  }

  openUserMenu(): void {
    if (this.userTrigger) {
      this.userTrigger.openMenu();
    }
  }

  closeUserMenu(): void {
    if (this.userTrigger) {
      this.userTrigger.closeMenu();
    }
  }

  setHistory(history: any): void {
    //this.logger.info("setHistory() -> history: " + history.url);
    this.router.navigateByUrl(history.url);
  }

  openHistoryInNewTab(history: any): void {
    window.open(history.url, '_blank');
  }
  public autoComplete(value: any) {
    // Type-ahead : chaque frappe alimente le flux (debounce 200 ms) ; rien quand la flotte est en SQL.
    this.suggestInput$.next(typeof value === 'string' ? value : '');
  }

  public search(value: any) {
    // Entrée avec une suggestion surlignée → ouvrir la fiche, pas la page de résultats.
    if (this.suggestionsOpen && this.activeSuggestion >= 0) {
      const chosen = this.suggestions[this.activeSuggestion];
      if (chosen) {
        this.openSuggestion(chosen);
        return;
      }
    }
    this.closeSuggestions();

    const isTestSearch: boolean = value instanceof Object;
    if (isTestSearch) {
      // this.logger.info("SEARCH TEST");
      if (!value.value || value.value.length < 2) {
        // TODO: add a visual warning for user
        //this.logger.info("WARNING: NO VALUE OR SMALLER THAN 3");
        this.loading = false;
        return;
      }

      this.loading = true;
      // Do your search here...
      //this.logger.info("ToolbarComponent.search() -> value: " + value);
      this.searchService.getSearchResultsTest(value.value).subscribe({
        next: (response) => {
          // this.logger.info("FuseToolbarComponent.search() -> SUCCESS: " + JSON.stringify(response));
          this.searchResultsSharedDataService.setSearchData(
            response,
            value.value,
          );
          const prefix = localStorage.getItem('PREFIX') || '';
          this.router.navigateByUrl(
            prefix + '/' + AppRoutes.SEARCH + '?keyword=' + value.value,
          );
          this.loading = false;
        },
        error: (error) => {
          this.logger.error(
            'FuseToolbarComponent.search() -> ERROR: ' + JSON.stringify(error),
          );
          this.loading = false;
        },
      });
    } else {
      //
      if (!value || value.length < 3) {
        //this.logger.info("WARNING: NO VALUE OR SMALLER THAN 3");
        this.loading = false;
        return;
      }

      this.loading = true;
      // Do your search here...
      //this.logger.info("ToolbarComponent.search() -> value: " + value);
      this.searchService.getSearchResults(value).subscribe({
        next: (response) => {
          const prefix = localStorage.getItem('PREFIX') || '';
          // this.logger.info("FuseToolbarComponent.search() -> SUCCESS: " + JSON.stringify(response));
          this.searchResultsSharedDataService.setSearchData(response, value);
          this.router.navigateByUrl(prefix + '/search?keyword=' + value);
          this.loading = false;
        },
        error: (error) => {
          this.logger.error(
            'FuseToolbarComponent.search() -> ERROR: ' + JSON.stringify(error),
          );
          this.loading = false;
        },
      });
    }
  }

  public onShop(): void {
    window.open(this.organization.shop_url, '_blank');
  }

  public onCreateNewEmployee(): void {
    this.dialogRef = this.dialog.open(CreateEmployeeComponent, {
      width: '340px',
      disableClose: false,
    });

    this.dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
          const prefix = localStorage.getItem('PREFIX') || '';
          this.router.navigateByUrl(prefix + ItemUrlFinder.getItemURL(result));
        }
        this.dialogRef = null;
      },
    });
  }

  public onCreateNewProduct(): void {
    //this.logger.info("FuseToolbarComponent.onCreateNewProduct()");
    this.dialogRef = this.dialog.open(CreateProductComponent, {
      width: '340px',
      disableClose: false,
    });

    this.dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
          const prefix = localStorage.getItem('PREFIX') || '';
          this.router.navigateByUrl(prefix + ItemUrlFinder.getItemURL(result));
        }
        this.dialogRef = null;
      },
    });
  }

  public onCreateNewProductCombo(): void {
    this.dialogRef = this.dialog.open(CreateProductComponent, {
      width: '340px',
      disableClose: false,
    });

    this.dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
          this.tranformProductIntoCombo(result);
        }
        this.dialogRef = null;
      },
    });
  }

  public onCreateNewProductComboDynamic(): void {
    this.dialogRef = this.dialog.open(CreateComboDynamicComponent, {
      width: '340px',
      disableClose: false,
    });

    this.dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
          const prefix = localStorage.getItem('PREFIX') || '';
          this.router.navigateByUrl(prefix + ItemUrlFinder.getItemURL(result));
        }
        this.dialogRef = null;
      },
    });
  }

  private tranformProductIntoCombo(product: any): void {
    this.editComboPanelService
      .open({ product: product, products: null, mode: 'create' })
      .subscribe({
        next: () => {
          const prefix = localStorage.getItem('PREFIX') || '';
          this.router.navigateByUrl(prefix + ItemUrlFinder.getItemURL(product));
        },
      });
  }

  public onCreateNewMaterialCombo(): void {
    //this.logger.info("FuseToolbarComponent.onCreateNewMaterialCombo()");
    this.dialogRef = this.dialog.open(CreateMaterialComponent, {
      width: '340px',
      disableClose: false,
    });

    this.dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
          this.tranformMaterialIntoCombo(result);
        }
        this.dialogRef = null;
      },
    });
  }

  private tranformMaterialIntoCombo(material: any): void {
    this.editMaterialComboPanelService
      .open({ material: material, materials: null, mode: 'create' })
      .subscribe({
        next: () => {
          const prefix = localStorage.getItem('PREFIX') || '';
          this.router.navigateByUrl(
            prefix + ItemUrlFinder.getItemURL(material),
          );
        },
      });
  }

  public onCreateNewPlace(): void {
    //this.logger.info("FuseToolbarComponent.onCreateNewPlace()");
    this.dialogRef = this.dialog.open(CreatePlaceComponent, {
      width: '62%',
      minWidth: 300,
      panelClass: 'scrollable-dialog',
      disableClose: false,
    });

    this.dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
          const prefix = localStorage.getItem('PREFIX') || '';
          this.router.navigateByUrl(prefix + ItemUrlFinder.getItemURL(result));
        }
        this.dialogRef = null;
      },
    });
  }

  public onCreateNewOrder(): void {
    if (this.dialogRef) {
      return;
    }
    //this.logger.info("FuseToolbarComponent.onCreateNewOrder()");
    this.dialogRef = this.dialog.open(CreateEventComponent, {
      width: '780px',
      maxWidth: '90vw',
      maxHeight: '96vh',
      minWidth: 300,
      panelClass: 'create-event-dialog',
      disableClose: false,
      data: {
        subType: CreateEventComponent.ORDER_SUBTYPE,
      },
    });

    this.dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        //this.logger.info("DashboardCalendarComponent.onNewEvent() -> result: " + JSON.stringify(result));
        if (result) {
          const prefix = localStorage.getItem('PREFIX') || '';
          this.router.navigateByUrl(prefix + ItemUrlFinder.getItemURL(result));
        }
        this.dialogRef = null;
      },
    });
  }

  public onNewQuickOrder(): void {
    this.featureTracking.trackFeature('quick-order-new-pickup');
    this.quickOrderPanelService.open().subscribe({
      next: (result: any) => {
        if (result) {
          const prefix = localStorage.getItem('PREFIX') || '';
          this.router.navigateByUrl(prefix + ItemUrlFinder.getItemURL(result));
        }
      },
    });
  }

  public onCreateNewCongress(): void {
    //this.logger.info("FuseToolbarComponent.onCreateNewCongress()");
    this.dialogRef = this.dialog.open(CreateCongresDialogComponent, {
      width: '440px',
      maxHeight: '96vh',
      minWidth: 300,
      disableClose: false,
      panelClass: 'scrollable-dialog',
      data: { autoRedirect: true },
    });
    this.dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        // if (result) {
        //     this.reloadTable();
        // }
        this.dialogRef = null;
      },
    });
  }

  public onCreateNewProposal(): void {
    if (this.dialogRef) {
      return;
    }
    //this.logger.info("FuseToolbarComponent.onCreateNewProposal()");
    this.dialogRef = this.dialog.open(CreateEventComponent, {
      width: '780px',
      maxWidth: '90vw',
      maxHeight: '96vh',
      minWidth: 300,
      panelClass: 'create-event-dialog',
      disableClose: false,
      data: {
        subType: CreateEventComponent.PROPOSAL_SUBTYPE,
      },
    });
    this.dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        //this.logger.info("DashboardCalendarComponent.onNewEvent() -> result: " + JSON.stringify(result));
        if (result) {
          const prefix = localStorage.getItem('PREFIX') || '';
          this.router.navigateByUrl(prefix + ItemUrlFinder.getItemURL(result));
        }
        this.dialogRef = null;
      },
    });
  }

  public onCreateNewEnterprise(): void {
    //this.logger.info("FuseToolbarComponent.onCreateNewEnterprise()");
    this.dialogRef = this.dialog.open(CreateEnterpriseComponent, {
      width: '340px',
      disableClose: false,
    });

    this.dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
          const prefix = localStorage.getItem('PREFIX') || '';
          this.router.navigateByUrl(prefix + ItemUrlFinder.getItemURL(result));
        }
        this.dialogRef = null;
      },
    });
  }

  public onCreateNewClient(): void {
    //this.logger.info("FuseToolbarComponent.onCreateNewClient()");
    this.dialogRef = this.dialog.open(CreateClientComponent, {
      width: '340px',
      disableClose: false,
    });

    this.dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
          const prefix = localStorage.getItem('PREFIX') || '';
          this.router.navigateByUrl(prefix + ItemUrlFinder.getItemURL(result));
        }
        this.dialogRef = null;
      },
    });
  }

  public onCreateNewClientEnterprise(): void {
    //this.logger.info("FuseToolbarComponent.onCreateNewClient()");
    this.dialogRef = this.dialog.open(CreateClientEnterpriseComponent, {
      width: '340px',
      disableClose: false,
    });

    this.dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
          const prefix = localStorage.getItem('PREFIX') || '';
          this.router.navigateByUrl(prefix + ItemUrlFinder.getItemURL(result));
        }
        this.dialogRef = null;
      },
    });
  }

  public onCreateNewMaterial(): void {
    //this.logger.info("FuseToolbarComponent.onCreateNewMaterial()");
    this.dialogRef = this.dialog.open(CreateMaterialComponent, {
      width: '340px',
      disableClose: false,
      data: {
        autoRedirect: true,
      },
    });

    this.dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        this.dialogRef = null;
      },
    });
  }

  public onProfile() {
    const prefix = localStorage.getItem('PREFIX') || '';
    this.router.navigateByUrl(prefix + ItemUrlFinder.getItemURL(this.employee));
  }

  // ---o Centre de notifications : cloche + « Mes préférences de notifications » (tous les forfaits, tous les rôles)
  public onBell(): void {
    this.bellPanelService.toggle();
  }

  public get bellBadge(): string {
    return this.unreadNotifications > 99
      ? '99+'
      : String(this.unreadNotifications);
  }

  public get bellAriaLabel(): string {
    if (this.unreadNotifications <= 0) {
      return this._translateService.instant('TOOLBAR.NOTIFICATIONS_NONE');
    }
    return this._translateService.instant(
      this.unreadNotifications === 1
        ? 'TOOLBAR.NOTIFICATIONS_ONE'
        : 'TOOLBAR.NOTIFICATIONS_MANY',
      { count: this.bellBadge },
    );
  }

  public onOrganization() {
    const prefix = localStorage.getItem('PREFIX') || '';
    this.router.navigateByUrl(
      prefix +
        '/' +
        AppRoutes.CATERERS +
        '/' +
        this.caterer.data.slug +
        '/' +
        this.caterer.data.uuid,
    );
  }

  public onCaterer() {
    const prefix = localStorage.getItem('PREFIX') || '';
    this.router.navigateByUrl(prefix + '/' + AppRoutes.CATERER);
  }

  public onPreferences(): void {
    const prefix = localStorage.getItem('PREFIX') || '';
    this.router.navigateByUrl(prefix + '/' + AppRoutes.PREFERENCES);
  }

  public onSettings(): void {
    const prefix = localStorage.getItem('PREFIX') || '';
    this.router.navigateByUrl(prefix + '/' + AppRoutes.SETTINGS);
  }

  public onResetTable(): void {
    this.featureTracking.trackFeature('reset-ui');

    // Dashboard operations specific keys
    localStorage.removeItem('LOCAL_STORED_SELECTED_COL_005');
    localStorage.removeItem('LOCAL_STORED_RANGE_FROM_001');
    localStorage.removeItem('LOCAL_STORED_RANGE_TO_001');
    localStorage.removeItem('LOCAL_STORED_DELIVERY_TYPE_SELECT_MODEL_001');
    localStorage.removeItem('LOCAL_STORED_STATUS_SELECT_MODEL_001');
    localStorage.removeItem('LOCAL_STORED_ORDER_STATUS_SELECT_MODEL_001');

    // All p-table stateKey entries
    const tableStateKeys = [
      'gt2test-local-36',
      'dashboard-event-session',
      'products-table',
      'clients-table',
      'enterprises-table',
      'materials-table',
      'congresses-table',
      'venues-table',
      'employees-table',
      'submissions-table',
      'sent-emails-table',
    ];
    tableStateKeys.forEach((key) => localStorage.removeItem(key));

    // All p-table column toggle entries
    const tableColumnKeys = [
      'products-table-columns',
      'clients-table-columns',
      'enterprises-table-columns',
      'materials-table-columns',
      'congresses-table-columns',
      'venues-table-columns',
      'employees-table-columns',
      'submissions-table-columns',
    ];
    tableColumnKeys.forEach((key) => localStorage.removeItem(key));

    setTimeout(() => {
      window.location.reload();
    }, 50);
  }

  public onLogout(): void {
    //this.logger.info("FuseToolbarComponent.onLogout()");
    this.auth.logout(true).subscribe({
      next: (response) => {
        // this.logger.info("FuseToolbarComponent.onLogout() -> SUCCESS: " + JSON.stringify(response));
        JwtInterceptor.LAST_URL_401 = null;
      },
      error: (error) => {
        this.logger.error(
          'FuseToolbarComponent.onLogout() -> ERROR: ' + JSON.stringify(error),
        );
      },
    });
  }

  public openMyMenu(event: MouseEvent) {
    //this.logger.info("FuseToolbarComponent.openMyMenu()");
    //this.logger.info(event);
    // this.logger.info("FuseToolbarComponent.openMyMenu() -> this.deviceService.device: " + this.deviceService.device);
    // this.logger.info("FuseToolbarComponent.openMyMenu() -> DEVICES.I_PAD: " + DEVICES.I_PAD);
    if (this.deviceService.device !== DEVICES.iPad) {
      // this.logger.info("FuseToolbarComponent.openMyMenu() -> NOT AN IPAD!!! ");
      this.trigger?.openMenu();
    }
  }

  public closeMyMenu() {
    // this.logger.info("FuseToolbarComponent.closeMyMenu()");
    this.trigger?.closeMenu();
    // this.createMenuButton.focus();
  }

  public openQuickOrderMenu(event?: MouseEvent) {
    if (this.deviceService.device !== DEVICES.iPad) {
      this.quickOrderTrigger?.openMenu();
    }
  }

  public closeQuickOrderMenu() {
    this.quickOrderTrigger?.closeMenu();
  }

  public onMenuClosed() {
    // this.logger.info("FuseToolbarComponent.openMyMenu() -> " + this.createMenuButton);
  }
}
